import { render, staticRenderFns } from "./AppraisalReport.vue?vue&type=template&id=d8f20a10"
import script from "./AppraisalReport.vue?vue&type=script&lang=ts"
export * from "./AppraisalReport.vue?vue&type=script&lang=ts"
import style0 from "./AppraisalReport.vue?vue&type=style&index=0&id=d8f20a10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports